// bp-crosssell.js — Blue Pets cart cross-sell v11
(function () {
  'use strict';

  if (window._bpCS) return;
  window._bpCS = true;

  function fmt(raw) {
    return '$' + Math.round(parseFloat(raw) / 100).toLocaleString('es-CL');
  }

  // Refresca el cart drawer usando el mecanismo nativo de Horizon
  function refreshCart() {
    // cart-lines:update es el evento de @shopify/events que Horizon escucha
    // Al resolverse la promise sin sections HTML, Horizon hace #refreshCartSection()
    var event = new CustomEvent('cart-lines:update', { bubbles: true });
    event.promise = Promise.resolve({ detail: {} });
    document.dispatchEvent(event);

    // Actualizar el contador del header como respaldo
    fetch('/cart.js')
      .then(function(r) { return r.json(); })
      .then(function(cart) {
        document.querySelectorAll('.cart-bubble__text-count').forEach(function(el) {
          el.textContent = cart.item_count;
          el.classList.remove('hidden');
        });
        document.querySelectorAll('.cart-bubble').forEach(function(el) {
          el.classList.remove('visually-hidden');
        });
      });
  }

  function makeCard(p, cartIds, addedIds, productPool) {
    var v   = (p.variants && p.variants[0]) ? p.variants[0] : {};
    var src = (p.featured_image || (p.images && p.images[0] && p.images[0].src) || '')
                .split('?')[0].replace(/([.][a-z]+)$/i, '_300x300$1');
    var price = v.price ? fmt(v.price) : '';

    var card = document.createElement('div');
    card.className   = 'bp-crosssell__item';
    card.dataset.pid = p.id;
    card.innerHTML   =
      '<a href="/products/' + p.handle + '" class="bp-crosssell__img-wrap">' +
      (src ? '<img src="' + src + '" alt="" loading="lazy" class="bp-crosssell__img">' : '') +
      '</a>' +
      '<p class="bp-crosssell__name">' + p.title + '</p>' +
      (price ? '<p class="bp-crosssell__price">' + price + '</p>' : '') +
      '<button class="bp-crosssell__btn" data-vid="' + (v.id || '') + '">+ Agregar</button>';

    card.querySelector('.bp-crosssell__btn').addEventListener('click', function () {
      var btn = this;
      var vid = parseInt(btn.dataset.vid);
      if (!vid) return;
      btn.textContent = '...';
      btn.disabled = true;

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: vid, quantity: 1 })
      })
        .then(function () {
          addedIds.push(p.id);
          btn.textContent = '✓ Agregado';
          btn.classList.add('bp-crosssell__btn--added');

          // Refrescar el listado del carrito para mostrar el producto nuevo
          refreshCart();

          // Reemplazar la tarjeta con el siguiente producto del pool
          setTimeout(function () {
            var next = productPool.find(function (pp) {
              return !cartIds.includes(pp.id) && !addedIds.includes(pp.id);
            });
            if (next) {
              productPool.splice(productPool.indexOf(next), 1);
              var newCard = makeCard(next, cartIds, addedIds, productPool);
              newCard.style.opacity = '0';
              if (card.parentNode) {
                card.parentNode.replaceChild(newCard, card);
                requestAnimationFrame(function () {
                  newCard.style.transition = 'opacity 0.35s';
                  newCard.style.opacity = '1';
                });
              }
            } else {
              card.style.transition = 'opacity 0.3s';
              card.style.opacity = '0';
              setTimeout(function () { card.style.visibility = 'hidden'; }, 320);
            }
          }, 800);
        })
        .catch(function () {
          btn.textContent = '+ Agregar';
          btn.disabled = false;
        });
    });

    return card;
  }

  var fetching    = false;
  var lastCartIds = '';

  function initCrossSell(el) {
    fetching    = true;
    lastCartIds = el.dataset.cartIds || '';
    el.style.display = '';

    var pid     = el.dataset.productId;
    var cartIds = (el.dataset.cartIds || '').split(',').map(Number).filter(Boolean);
    var addedIds    = [];
    var productPool = [];

    function renderProducts(products) {
      fetching = false;
      var grid = document.getElementById('bp-crosssell-grid');
      if (!grid) return;

      var available = products.filter(function (p) {
        return !cartIds.includes(p.id) && p.available !== false;
      });

      if (!available.length) { el.style.display = 'none'; return; }

      var toShow  = available.slice(0, 4);
      productPool = available.slice(4);

      grid.innerHTML = '';
      toShow.forEach(function (p) {
        grid.appendChild(makeCard(p, cartIds, addedIds, productPool));
      });
    }

    var recsP = pid
      ? fetch('/recommendations/products.json?product_id=' + pid + '&limit=10&intent=related')
          .then(function (r) { return r.json(); })
          .catch(function () { return { products: [] }; })
      : Promise.resolve({ products: [] });

    var allP = fetch('/collections/all/products.json?limit=16&sort_by=best-selling')
      .then(function (r) { return r.json(); })
      .catch(function () { return { products: [] }; });

    Promise.all([recsP, allP]).then(function (results) {
      var recs     = results[0].products || [];
      var all      = results[1].products || [];
      renderProducts(recs.length >= 2 ? recs : all);
    }).catch(function () {
      fetching = false;
      el.style.display = 'none';
    });
  }

  function checkAndLoad() {
    var el = document.getElementById('bp-crosssell');
    if (!el) return;
    var currentCartIds = el.dataset.cartIds || '';
    if (fetching && currentCartIds !== lastCartIds) fetching = false;
    if (fetching) return;
    var grid = document.getElementById('bp-crosssell-grid');
    if (!grid || grid.querySelector('.bp-crosssell__item')) return;
    initCrossSell(el);
  }

  checkAndLoad();
  setInterval(checkAndLoad, 300);
})();
